import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CASES_FEATURE_KEY, State } from "./cases.reducer";
import { Workspace } from "@telespot/sdk";

export const getCurrentWorkspace = (state: State) =>
  state.currWorkspace
    ? (Workspace.fromJSON({
        ...state.currWorkspace,
        className: "Workspace",
      }) as Workspace)
    : undefined;

export const getCasesState = createFeatureSelector<State>(CASES_FEATURE_KEY);

export const selectdecrypted = createSelector(getCasesState, (state: State) => {
  return state?.decrypted;
});

export const selectDecryptedCases = createSelector(
  getCasesState,
  (state: State) => {
    return state?.decryptedCases;
  }
);

export const selectUndecryptedCases = createSelector(
  getCasesState,
  (state: State) => {
    return state?.cases.filter(
      (c) => !state?.decryptedCases.find((dc) => dc.objectId === c.objectId)
    );
  }
);

export const selectCases = createSelector(getCasesState, (state: State) => {
  return state?.decrypted ? state?.decryptedCases : state.cases;
});

export const currDecryptedCase = (id: string) =>
  createSelector(getCasesState, (state: State) => {
    return state?.decryptedCases.find((c) => c.objectId === id);
  });

export const getCurrentCase = (id: string) =>
  createSelector(getCasesState, (state: State) => {
    return state?.decrypted
      ? state?.decryptedCases.find((c) => c.objectId === id)
      : state?.cases.find((c) => c.objectId === id);
  });

export const selectWSEncrypted = createSelector(
  getCasesState,
  (state: State) => {
    return state?.currWorkspace?.caseType.fields.some(
      (field) => field.encrypted
    );
  }
);

export const selectIsCaseEncrypted = createSelector(
  getCasesState,
  (state: State) => {
    return state?.currWorkspace?.caseType.fields.some(
      (field) => field.type === "case_name" && field.encrypted
    );
  }
);

export const selectCurrentWorkspace = createSelector(
  getCasesState,
  getCurrentWorkspace
);

export const selectCurrCaseAndWorkspace = (id: string) =>
  createSelector(
    selectCurrentWorkspace,
    getCurrentCase(id),
    (workspace, _case) => ({ workspace, _case })
  );

export const selectWorkspaceFilterPaginationAndSorts = createSelector(
  getCasesState,
  (state: State) => ({
    workspace: getCurrentWorkspace(state),
    limit: state.pageSize,
    skip: state.pageSize * state.pageIndex,
    sorts: state.sorts,
    filters: Object.values(state.filters.entities),
  })
);

export const currentCaseId = createSelector(getCasesState, (state: State) => {
  return state?.currentCaseId;
});
